<template>
  <div style="width: 100%">
    <pre id="repl" class="repl">{{ replText }}</pre>
    <span class="prompt"> ></span>
    <input
      v-model="replIn"
      @keydown.enter.prevent="submit"
      ref="replIn"
      id="replIn"
      class="replIn"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { auth } from '@/api/http'

export default {
  name: 'repl',

  computed: {
    ...mapState({
      stats: state => state.stats.stats,
    }),
  },

  data() {
    return {
      lines: [],
      replText: '',
      replIn: '',
      tempEnter: null,
      replOptions: [
        '       *** help menu ***',
        'type a CMD and its options...',
        'CMD   -description',
        ' h    -help: print this menu',
        ' l    -list [authors, titles, collections]',
        '       ex: l collections<enter>',
        '       ex: l authors<enter>',
      ],
      printing: false,
    }
  },

  methods: {
    ...mapActions({
      getStats: 'stats/getStats',
      notify: 'util/notify',
      sleep: 'util/sleep',
    }),

    async submit() {
      this.lines.push('\n> ' + this.replIn)
      const str = this.replIn
      this.replIn = ''
      const tokens = str.trim().split(/\s+/)
      const validCommands = ['h', 'l', 'n']
      const validLis = ['authors', 'collections']
      // const validCols = this.stats && this.stats
      const validCols = ['en_documents', 'authors']

      const cmd = tokens[0].toLowerCase()
      if (cmd === '') {
        if (this.tempEnter) {
          this.tempEnter()
        }
        return
      }
      if (!validCommands.includes(cmd)) {
        return this.lines.push(`!err invalid cmd
  valid cmds: [${validCommands.join(' ')}]
  type h for help`)
      }
      if (cmd === 'h') {
        this.lines.push(...this.replOptions)
      } else if (cmd === 'l') {
        if (!validLis.includes(tokens[1])) {
          return this.lines.push(
            `!err invalid item
  valid items: [
\t${validLis.join('\n\t')}
  ]`,
          )
        }

        if (tokens[1] === 'collections') {
          const t = Object.keys(this.stats.totals)
            .map(c => ({ name: c, total: this.stats.totals[c] }))
            .sort((a, b) => a.total < b.total)
            .map(c => `${c.name}: ${c.total}`)
            .join('\n')
          return this.lines.push(
            `*** ${tokens[1]} ***
${t}`,
          )
        } else if (tokens[1] === 'authors') {
          this.tempEnter = this.next
          return this.next(0, 5, tokens)
        }
      } else if (cmd === 'n') {
        return this.notify({ msg: tokens.slice(1).join(' '), color: '#38ad29' })
      }
    },
    next(s, e, t) {
      this.s = s || this.e
      this.e = e || this.e + 5
      this.t = t || this.t
      const a = this.stats.authors
        .map(au => `${au.au}: ${au.l}`)
        .slice(this.s, this.e)
        .join('\n')

      this.lines.push(
        `*** ${this.t[1]}: ${this.s || 1}-${this.e} ***
${a}
<enter for next 5>`,
      )
    },

    async print() {
      if (this.printing) {
        await this.sleep(100)
        return this.print()
      }
      const len = this.lines.length
      this.printing = true
      const repl = document.getElementById('repl')
      let letters = this.lines.join('\n').split('')
      for (let i = 0; i < letters.length; i++) {
        repl.scrollTop = repl.scrollHeight
        let letter = letters[i]
        const time = Math.random() * 15 + 5
        await this.sleep(time)
        this.replText += letter
      }
      this.lines.splice(0, len)
      this.printing = false
    },
  },

  async created() {
    this.lines.push(`Welcome, ${this.name || this.email || 'friend'}
What can Ptolemy do for you?
type h<enter> for help`)
    // Nineveh, the mother who bore me, ...
    // do a rollup of nineveh quotes
    // sample searches
    // get stats
    if (this.stats) return
    await this.getStats()
    if (!this.stats) {
      this.lines.push("!err: couldn't find stats")
    }
  },

  watch: {
    lines(val) {
      val.length && this.print()
    },
  },
}
</script>

<style scoped>
.repl {
  margin: 0px;
  padding: 4px;
  background-color: #000;
  color: #25ec87;
  height: 300px;
  overflow-wrap: anywhere;
  overflow-x: hidden;
  overflow-y: scroll;
  font-family: Monda;
}
.prompt {
  display: inline-flex;
  margin: 0;
  padding: 3px;
  font-size: 17px;
  font-weight: bold;
  background-color: #000;
  color: #25ec87;
}
.replIn {
  display: inline-flex;
  width: 95%;
  margin: 0;
  padding: 0;
  border: 0;
  font-family: Monda;
  font-size: 16px;
  font-weight: bold;
  background-color: #000;
  color: #25ec87;
}
</style>
